import { v4 as uuidv4 } from 'uuid';

export default class IdsHelper {
  static getNewUuid() {
    return uuidv4();
  }
}
